import React from 'react';

import { useForm } from "react-hook-form";
import { emailUserGroup } from "root/DataFunctions/ContactUsersFns";
import ModalContentWrapper from "./ModalContentWrapper";
import './ModalUploadDocument.scss';
import { ALL_USERS, ONE_USER, UNSUBMITTED_USERS } from "root/TeachersContainer";
import FormFragmentEmailBody from "root/EmailAll/FormFragmentEmailBody";
import FormFragmentTitle from "root/EmailAll/FormFragmentTitle";
import FormFragmentSignature from "root/EmailAll/FormFragmentSignature";


export const EMAIL_ALL_SECTION = 'emailall'

export const EMAIL_ALL_FIELDS = {
    TITLE: 'title',
    MESSAGE: 'message',
    SIGN: 'sign'
}

const ModalEmailAll = ( { onSaveCompleted, onClose, targetGroupString, provider_id, user_id, params, mode } ) =>
{
    const { register, control, handleSubmit, setFocus, setValue, watch, formState: { errors: formErrors } } = useForm (
        {
            defaultValues: {
                [EMAIL_ALL_SECTION]: {
                    [EMAIL_ALL_FIELDS.TITLE]: '',
                    [EMAIL_ALL_FIELDS.MESSAGE]: '',
                    [EMAIL_ALL_FIELDS.SIGN]: '',
                }
            }
        } );

    const getTitle = (targetGroupString) =>
    {
        return (
            <div>
                { targetGroupString === ALL_USERS && <h3>Contact All Users</h3> }
                { targetGroupString === UNSUBMITTED_USERS && <h3 style={{color: "red"}}>Contact Unsubmitted Users</h3> }
            </div>
        )
    }

    const primaryButtonStyle = {
        marginRight: '0px',
        marginLeft: '10px'
    };

    const onCancel = () =>
    {
        onClose();
    }

    const onSubmit = (data) =>
    {
        const sectionData = data[EMAIL_ALL_SECTION];

        emailUserGroup(targetGroupString, sectionData.title, sectionData.message, sectionData.sign)

        console.log(data);

        onSaveCompleted();
    }

    const formContent = () =>
    {
        return (
            <div className='buy-card'>
                <div>{ getTitle(targetGroupString) }</div>
                <form className='email-all-form' onSubmit={ handleSubmit ( onSubmit ) }>

                    <FormFragmentTitle control={control} formErrors={formErrors} register={register} sectionName={EMAIL_ALL_SECTION}/>

                    <FormFragmentEmailBody control={control} formErrors={formErrors} register={register} sectionName={EMAIL_ALL_SECTION}/>

                    <FormFragmentSignature control={control} formErrors={formErrors} register={register} sectionName={EMAIL_ALL_SECTION}/>

                    <div className='modal-button-row'>
                        <button onClick={ () => onCancel () } type="button"
                                className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/></button>
                        <button type="submit" style={ primaryButtonStyle }
                                className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Send Message<i className="et-check"/></button>
                    </div>
                </form>
            </div>
        );

    }


    return (
        <ModalContentWrapper className='modal-one-column'>
            { formContent () }
        </ModalContentWrapper>
    );
}

export default ModalEmailAll;